module.exports = __webpack_public_path__ + "static/media/tommyFlagLogo.96b979f4.svg";